import Link from "next/link"
import { CardText } from "reactstrap"

import TranslatedHtml from "@components/common/TranslatedHtml"
import { withDynamicNamespaces } from "@components/hoc/withDynamicNamespaces"
import { OnboardingType } from "@redux/usecases/onboarding"
import { NamespaceShortcut, useDynamicTranslation } from "@services/i18n"
import { Routes } from "@services/routes"

const usedNamespaces: NamespaceShortcut[] = ["onboarding"]

type InvitationProps = {
  unsavedOnboardingType: OnboardingType
}

/**
 * This component shows the login/register buttons during an onboarding process, that invites the user to authenticate.
 */
const OnboardingLoginRegisterInvitationButtons: React.FC<InvitationProps> = (props: InvitationProps) => {
  const t = useDynamicTranslation()

  const conjugatedOnboardingTypeWithArticle = t("onboarding", props.unsavedOnboardingType + ".accusativeWithDefiniteArticle")

  return <>
    <CardText className="text-center">
      <TranslatedHtml
        content={t("onboarding", "saveViaLogin", { onboardingDataWithDefiniteArticle: conjugatedOnboardingTypeWithArticle })}
      />
    </CardText>
    <CardText className="text-center">
      <Link href={Routes.Login}>
        <a className="btn primary-btn">{t("common", "goto.login")}</a>
      </Link>
    </CardText>
    <CardText className="text-center">
      <TranslatedHtml
        content={t("onboarding", "saveViaRegistration", { onboardingDataWithDefiniteArticle: conjugatedOnboardingTypeWithArticle })}
      />
    </CardText>
    <CardText className="text-center">
      <Link href={Routes.Registration}>
        <a className="btn primary-btn">{t("common", "goto.registration")}</a>
      </Link>
    </CardText>

  </>
}

export default withDynamicNamespaces<InvitationProps>(OnboardingLoginRegisterInvitationButtons, usedNamespaces)
